import { render, staticRenderFns } from "./DuplicateAssignmentLibrary.vue?vue&type=template&id=bba32996&scoped=true&"
import script from "./DuplicateAssignmentLibrary.vue?vue&type=script&lang=js&"
export * from "./DuplicateAssignmentLibrary.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateAssignmentLibrary.vue?vue&type=style&index=0&id=bba32996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba32996",
  null
  
)

export default component.exports